import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import moment from 'moment';
import { getCityList as getCityData } from '@/apis/commonApi';

function formatListParams(params) {
  const postParams = {
    ...params,
    billTime: undefined,
    billBeginTime: params.billTime ? moment(params.billTime[0]).valueOf() : undefined,
    billEndTime: params.billTime ? moment(params.billTime[1]).valueOf() : undefined,
    companySettlementStatus: Number(params.companySettlementStatus),
  };
  return postParams;
}

const model = {
  state: {
    // 列表页面
    params: {
      companySettlementStatus: '-1',
      pageSize: 50,
      page: 1,
    },
    list: [],
    listLoading: false,
    listTotal: 0,
    // 详情弹窗
    detailVisible: false,
    detailBillId: null,
    detailParams: {
      companyId: '',
      pageSize: 20,
      page: 1,
    },
    detailData: {},
    detailCompanys: [],
    detailList: [],
    detailListLoading: false,
    detailListTotal: 0,
    // 调账弹窗
    adjustVisible: false,
    adjustBillId: null,
    // 订单递减
    reduceParams: {
      pageSize: 20,
      page: 1,
    },
    reduceList: [],
    reduceListLoading: false,
    reduceListTotal: 0,
    // 订单递增
    increaseParams: {
      pageSize: 20,
      page: 1,
    },
    increaseList: [],
    increaseListLoading: false,
    increaseListTotal: 0,
    // 添加订单
    addVisible: false,
    addCompanyId: null,
    addParams: {
      pageSize: 20,
      page: 1,
    },
    addList: [],
    addListLoading: false,
    addListTotal: 0,
    // 人工创建账单
    manualVisible: false,
    manualBillId: null,
    settleList: [],
    // 城市列表
    cityList: [
      {
        title: '全部',
        value: '',
      },
    ],
    largeAreaList: [],
    // 订单详情-默认本期明细
    detailActiveKey: '1',
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { billEnterprise, basic }, getState }) => ({
    // 获取企业账单列表
    async getList() {
      billEnterprise.setState({ listLoading: true });
      const { params } = getState().billEnterprise;
      const data = await fetch('/saasmerchant/fsarea/billorder/companybillorderlist', {
        params: filterNull(formatListParams(params)),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        billEnterprise.setState({
          list: data.list || [],
          listTotal: data.total,
          totalBillPrice: data.totalBillPrice,
        });
      }
      billEnterprise.setState({ listLoading: false });
    },
    // 搜索
    onSearch(params) {
      billEnterprise.setState({ params });
    },
    // 底部换页
    onNav(page) {
      const { params } = getState().billEnterprise;
      billEnterprise.setState({ params: { ...params, page } });
    },
    // 重置筛选项
    onReset() {
      billEnterprise.setState({
        params: {
          companySettlementStatus: '-1',
          pageSize: 50,
          page: 1,
        },
      });
    },
    onTabsChange(status) {
      const { params } = getState().billEnterprise;
      billEnterprise.setState({
        params: {
          ...params,
          page: 1,
          companySettlementStatus: status,
        },
      });
    },

    async exportAllBill(props) {
      const data = await fetch('/saasmerchant/fsarea/billorder/batchallexportbillorder', {
        params: filterNull(formatListParams(props)),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('账单导出成功');
        basic.setLogListDot(true);
      } else {
        message.error('账单导出失败');
      }
    },

    // 导出账单列表
    async exportBillOrder(props) {
      const data = await fetch('/saasmerchant/fsarea/billorder/exportbillorder', {
        params: filterNull(formatListParams(props)),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('账单列表导出成功');
        basic.setLogListDot(true);
      }
    },

    // 批量导出账单
    async batchExportBillOrder(billOrderIds) {
      const data = await fetch('/saasmerchant/fsarea/billorder/batchexportbillorder', {
        params: {
          billOrderIds,
        },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('账单导出成功');
        basic.setLogListDot(true);
      }
    },
    // 账单推送
    async pushBillOrder(params) {
      const data = await fetch('/saasmerchant/fsarea/billorder/billorderpush', {
        params,
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('账单推送成功');
        billEnterprise.getList();
      }
    },
    // 批量账单推送
    async batchPushBillOrder(billOrderIds) {
      const data = await fetch('/saasmerchant/fsarea/billorder/billorderbatchpushemail', {
        params: { billOrderIds },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('批量账单推送成功');
        billEnterprise.getList();
      }
    },
    // 确认收款
    async confirmBillOrderList(billOrderId) {
      const data = await fetch('/saasmerchant/fsarea/billorder/billorderconfirm', {
        params: { billOrderId },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('确认收款成功');
        billEnterprise.getList();
      }
    },
    // 批量确认收款
    async batchConfirmBillOrder(billOrderIds) {
      const data = await fetch('/saasmerchant/fsarea/billorder/billorderbatchconfirm', {
        params: { billOrderIds },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        message.success('批量确认收款成功');
        billEnterprise.getList();
      }
    },
    // 获取账单详情
    getDetail(row) {
      billEnterprise.setState({ detailData: row });
    },
    // 获取账单详情列表
    async getDetailList() {
      billEnterprise.setState({ listLoading: true });
      const { detailBillId, detailParams } = getState().billEnterprise;
      // const { companyId } = detailParams;
      const data = await fetch('/saasmerchant/fsarea/billorder/subcompanybillorderlist', {
        params: filterNull({
          billOrderId: detailBillId,
          ...detailParams,
          // companyId: companyId ? Number(companyId) : null,
        }),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        billEnterprise.setState({
          detailCompanys: data.companys || [],
        });
      }
      billEnterprise.setState({ listLoading: false });
    },
    // 底部换页
    onDetailNav(page) {
      const { detailParams } = getState().billEnterprise;
      billEnterprise.setState({ detailParams: { ...detailParams, page } });
    },
    // 重置筛选项
    onDetailReset() {
      billEnterprise.setState({
        detailParams: {
          companyId: '',
          pageSize: 20,
          page: 1,
        },
      });
    },
    onDetailTabsChange(companyId) {
      const { detailParams } = getState().billEnterprise;
      billEnterprise.setState({
        detailParams: {
          ...detailParams,
          companyId,
        },
      });
    },
    setDetailVisible(visible, id) {
      billEnterprise.setState({ detailVisible: visible, detailBillId: id });
    },
    setAdjustVisible(visible, id) {
      billEnterprise.setState({ adjustVisible: visible, adjustBillId: id });
    },
    setManualVisible(visible) {
      billEnterprise.setState({ manualVisible: visible });
    },

    // 订单详情-设置本期明细/上期退款明细【tab切换】
    setDetailActiveKey(val) {
      val += '';
      billEnterprise.setState({ detailActiveKey: val });
    },

    // 调账
    async checkBill(params) {
      const {
        changePriceType, // 1：无订单调账 2：调整订单范围
        changePrice,
        changePriceReason,
        isCancel, // 0: 取消调账 1: 确认调账
        isManual,
      } = params;
      const { manualBillId, adjustBillId } = getState().billEnterprise;
      const billOrderId = isManual ? manualBillId : adjustBillId;
      if (billOrderId) {
        const postParams = {
          changePriceType,
          billOrderId: isManual ? manualBillId : adjustBillId,
          changePrice: changePrice && changePrice * 100,
          changePriceReason,
          isCancel,
        };
        const data = await fetch('/saasmerchant/fsarea/billorder/checkbill', {
          params: filterNull(postParams),
          type: 'POST',
          useJson: true,
        });
        if (data && !isCancel) {
          message.success(isManual ? '创建成功' : '调账成功');
          billEnterprise.getList();
        }
        billEnterprise.clearManualBillId();
      }
    },
    // 获取订单调减
    async getReduceList() {
      billEnterprise.setState({ reduceListLoading: true });
      const { reduceParams, adjustBillId } = getState().billEnterprise;
      const data = await fetch('/saasmerchant/fsarea/billorder/checkbillreducelist', {
        params: filterNull({
          ...reduceParams,
          billOrderId: adjustBillId,
          billTime: undefined,
          beginFinishTime: reduceParams.billTime
            ? `${moment(reduceParams.billTime[0]).format('YYYY-MM-DD')} 00:00:00`
            : undefined,
          endFinishTime: reduceParams.billTime
            ? `${moment(reduceParams.billTime[1]).format('YYYY-MM-DD')} 23:59:59`
            : undefined,
        }),
        type: 'GET',
      });
      if (data) {
        billEnterprise.setState({
          reduceList: data.list || [],
          reduceListTotal: data.total || 0,
        });
      }
      billEnterprise.setState({ reduceListLoading: false });
    },
    // 搜索
    onReduceSearch(params) {
      billEnterprise.setState({ reduceParams: params });
    },
    // 底部换页
    onReduceNav(page) {
      const { reduceParams } = getState().billEnterprise;
      billEnterprise.setState({ reduceParams: { ...reduceParams, page } });
    },
    // 重置筛选项
    onReduceReset() {
      billEnterprise.setState({
        reduceParams: {
          pageSize: 20,
          page: 1,
        },
      });
    },
    // 取消/恢复入账
    async editBill(orderId, type) {
      const { adjustBillId } = getState().billEnterprise;
      const data = await fetch('/saasmerchant/fsarea/billorder/editbill', {
        params: {
          orderId,
          billOrderId: adjustBillId,
          type,
        },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        billEnterprise.getReduceList();
      }
    },
    // 获取订单调增
    async getIncreaseList() {
      const { increaseParams, adjustBillId, manualVisible, addCompanyId, manualBillId } =
        getState().billEnterprise;
      const billOrderId = manualVisible ? manualBillId : adjustBillId;
      if (addCompanyId && billOrderId) {
        billEnterprise.setState({ increaseListLoading: true });
        const data = await fetch('/saasmerchant/fsarea/billorder/checkbillincreaselist', {
          params: filterNull({
            ...increaseParams,
            billOrderId,
            companyId: addCompanyId, // 人工创建订单传参加入结算主体
          }),
          type: 'GET',
        });
        if (data) {
          billEnterprise.setState({
            increaseList: data.list || [],
            increaseListTotal: data.total || 0,
          });
        }
        billEnterprise.setState({ increaseListLoading: false });
      } else {
        billEnterprise.setState({
          increaseList: [],
          increaseListTotal: 0,
        });
      }
    },
    // 底部换页
    onIncreaseNav(page) {
      const { increaseParams } = getState().billEnterprise;
      billEnterprise.setState({ increaseParams: { ...increaseParams, page } });
    },
    // 重置筛选项
    onIncreaseReset() {
      billEnterprise.setState({
        increaseParams: {
          pageSize: 20,
          page: 1,
        },
      });
    },
    // 删除订单调增
    async deleteIncrease(orderId) {
      const { adjustBillId, manualVisible, manualBillId } = getState().billEnterprise;
      const data = await fetch('/saasmerchant/fsarea/billorder/delincrease', {
        params: {
          orderId,
          billOrderId: manualVisible ? manualBillId : adjustBillId,
        },
        type: 'POST',
        useJson: true,
      });
      if (data) {
        billEnterprise.getIncreaseList();
      }
    },
    // 订单选择结算主体
    setAddCompanyId(addCompanyId) {
      billEnterprise.setState({ addCompanyId });
    },
    // 结算主体列表
    async getSettleList() {
      const data = await fetch('/saasmerchant/fsarea/billorder/getAllCompanyList', {
        type: 'GET',
      });
      if (data) {
        billEnterprise.setState({ settleList: data.list });
      }
    },
    // 添加订单
    async getAddList() {
      const { addParams, addCompanyId } = getState().billEnterprise;
      if (addCompanyId) {
        billEnterprise.setState({ addListLoading: true });
        const data = await fetch('/saasmerchant/fsarea/billorder/billaddorderlist', {
          params: filterNull({
            ...addParams,
            companyId: addCompanyId, // 人工创建订单传参加入结算主体
            billTime: undefined,
            beginFinishTime: addParams.billTime
              ? moment(addParams.billTime[0]).format('YYYY-MM-DD')
              : undefined,
            endFinishTime: addParams.billTime
              ? moment(addParams.billTime[1]).format('YYYY-MM-DD')
              : undefined,
          }),
          type: 'GET',
        });
        if (data) {
          billEnterprise.setState({
            addList: data.list || [],
            addListTotal: data.total || 0,
          });
        }
        billEnterprise.setState({ addListLoading: false });
      } else {
        billEnterprise.setState({
          addList: [],
          addListTotal: 0,
        });
      }
    },
    // 搜索
    onAddSearch(params) {
      billEnterprise.setState({ addParams: params });
    },
    // 底部换页
    onAddNav(page) {
      const { addParams } = getState().billEnterprise;
      billEnterprise.setState({ addParams: { ...addParams, page } });
    },

    // 重置筛选项
    onAddReset() {
      billEnterprise.setState({
        addParams: {
          pageSize: 20,
          page: 1,
        },
      });
    },
    clearManualBillId() {
      billEnterprise.setState({ manualBillId: null });
    },
    // 批量添加入账
    async batchAddOrder(orderIds) {
      const { adjustBillId, manualVisible, manualBillId, addCompanyId } = getState().billEnterprise;
      const newOrderIds = orderIds?.filter(Boolean);
      const data = await fetch('/saasmerchant/fsarea/billorder/addorderbatch', {
        params: filterNull({
          orderIds: newOrderIds,
          billOrderId: manualVisible ? manualBillId : adjustBillId,
          companyId: addCompanyId,
        }),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        // 人工创建订单时第一次添加入账获取账单id
        if (manualVisible && !manualBillId) {
          billEnterprise.setState({ manualBillId: data });
        }
        billEnterprise.getAddList();
      }
    },
    setAddVisible(visible) {
      billEnterprise.setState({ addVisible: visible });
    },

    // 将所有筛选结果添加入账
    async addAllBill(values) {
      const { manualVisible, manualBillId, addCompanyId } = getState().billEnterprise;
      const data = await fetch('/saasmerchant/fsarea/billorder/addallorders', {
        params: filterNull({
          ...values,
          companyId: addCompanyId,
          billTime: undefined,
          beginFinishTime: values.billTime
            ? moment(values.billTime[0]).format('YYYY-MM-DD')
            : undefined,
          endFinishTime: values.billTime
            ? moment(values.billTime[1]).format('YYYY-MM-DD')
            : undefined,
        }),
        type: 'POST',
        useJson: true,
      });
      if (data) {
        if (manualVisible && !manualBillId) {
          billEnterprise.setState({ manualBillId: data });
        }
        billEnterprise.getAddList();
        message.success('添加成功');
      }
    },

    // 获取城市列表数据
    async getCityList() {
      const data = await getCityData();
      const cityList = data?.map((province) => province.children || []).flat() || [];
      billEnterprise.setState({
        cityList,
      });
    },

    // 获取地区列表数据
    async getLargeAreaList() {
      // const {largeAreaList} = getState().billEnterprise;
      const data = await fetch('/saasmerchant/web/area/large/list');
      if (data) {
        billEnterprise.setState({
          largeAreaList: data,
        });
      } else {
        billEnterprise.setState({
          largeAreaList: [],
        });
      }
    },
  }),
};

export default model;
